import { render } from "./Sidebar.vue?vue&type=template&id=0fcf087a&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=0fcf087a&scoped=true&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=0fcf087a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcf087a"]])

export default __exports__